import React from "react";
import { Location } from "@navigation/Location";
import { MassContactActionsStoreOptions } from "./MassContactActionsStore";
import { MassContactActions } from "./MassContactActions";
import { ContactListColumn } from "./components/ContactList";

export class MassActionsLocation extends Location<{
  columns: ContactListColumn[];
  options: MassContactActionsStoreOptions;
}> {
  render() {
    return (
      <MassContactActions columns={this.params.columns} options={this.params.options} />
    );
  }

  toURI(): string {
    return `/mass-actions/${this.params.options.nodeType.toLowerCase()}`;
  }
}
